import { IIndirectTaxFilingsV2ListParams } from './types';

export function buildIndirectTaxFilingsV2ListQuery(
  filters: IIndirectTaxFilingsV2ListParams
): URLSearchParams {
  const query = new URLSearchParams();

  query.append('corporationId', filters.corporationId.toString());

  if (filters.registrationTaxTypeId) {
    query.append('registrationTaxTypeId', filters.registrationTaxTypeId);
  }
  if (filters.jurisdictionIds?.length) {
    query.append('jurisdictionIds', filters.jurisdictionIds.join(','));
  }
  if (filters.filingStatuses?.length) {
    query.append('filingStatuses', filters.filingStatuses.join(','));
  }
  if (filters.filingFrequencies?.length) {
    query.append('filingFrequencies', filters.filingFrequencies.join(','));
  }
  if (filters.fromDueDate) {
    query.append('fromDueDate', filters.fromDueDate);
  }
  if (filters.toDueDate) {
    query.append('toDueDate', filters.toDueDate);
  }
  if (filters.cursor) {
    query.append('cursor', filters.cursor);
  }
  if (filters.limit) {
    query.append('limit', filters.limit.toString());
  }
  if (filters.includeServiceRequest) {
    query.append('includeServiceRequest', 'true');
  }
  if (filters.includeAssignedUser) {
    query.append('includeAssignedUser', 'true');
  }
  if (filters.includeFiledByAgent) {
    query.append('includeFiledByAgent', 'true');
  }
  if (filters.extend?.length) {
    query.append('extend', filters.extend.join(','));
  }

  return query;
}
